import React from 'react';
import { components } from 'react-select';
import CrossIcon from '@atlaskit/icon/glyph/editor/close';
import DownIcon from '@atlaskit/icon/glyph/hipchat/chevron-down';

// indicators
export var ClearIndicator = function ClearIndicator(props) {
  return React.createElement(
    components.ClearIndicator,
    props,
    React.createElement(CrossIcon, null)
  );
};
export var DropdownIndicator = function DropdownIndicator(props) {
  return React.createElement(
    components.DropdownIndicator,
    props,
    React.createElement(DownIcon, null)
  );
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/select/dist/esm/components/indicators.js
// module id = 496
// module chunks = 0